export default __webpack_public_path__ + "static/media/favicon.8e2696a8.png";